import {createField} from './fieldModel';
/*
    Form class
    array of fields object
*/
function Form({
  fields
}) {
  //field objects, to access individually by field name
  const fieldsObj = {};
  fields.forEach(f => fieldsObj[f.name] = f);
    
  Object.assign(this, {
    fields, //fields array
    ...fieldsObj, //field objects
    errors: []
  });
    
  this.validate = () => {
    this.fields.filter(f => f.validate());
    this.errors = fields.reduce((acc,f) => {
      f.errors.forEach(error => {
        if(acc.indexOf(error) === -1) {
          acc.push(error);
        }
      });
      return acc;
    }, []);
    return this.errors.length===0;
  };

  this.resetErrors = () => {
  
    this.fields.forEach(f => f.resetErrors());
  };

  this.toJson = () => {
    if(typeof this.mapJson === 'function') {
      return this.mapJson(this.fields);
    } else {
      const jsonObject = {};
      this.fields.forEach(f => {
        jsonObject[f.name] = f.value || f.defaultValue;
      });
      return jsonObject;
    }
  };
}

const createForm = (fields) => {
  fields = fields.map(f => createField(f));
  return new Form({fields});
};

export {
  createForm
};
